module.exports = __webpack_public_path__ + "img/10.45f04f55.png";